import { render, staticRenderFns } from "./product-filter-group-list.vue?vue&type=template&id=8fc88522"
import script from "./product-filter-group-list.vue?vue&type=script&lang=js"
export * from "./product-filter-group-list.vue?vue&type=script&lang=js"
import style0 from "./product-filter-group-list.vue?vue&type=style&index=0&id=8fc88522&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports